export default __webpack_public_path__ + "static/media/dog_sit_12fps.47540cf1.gif";